import React, { Component } from 'react'
import { connect } from 'react-redux';
import AsCategoryWidget from './airship-wrappers/AsCategoryWidget';
import { withCarto } from '../carto/withCarto';

class DpsCategoryWidget extends Component {
  state = {
    categories: []
  }

  constructor(props) {
    super(props)
    this.ref = React.createRef()
  }

  componentDidMount() {
    this.props.CartoContext.dataviews[this.props.dataview].on('dataChanged', this.updateCategories)
  }

  componentWillUnmount() {
    this.props.CartoContext.dataviews[this.props.dataview].off('dataChanged', this.updateCategories)
  }

  updateCategories = (data) => {
    this.setState(state => ({
      ...state,
      categories: data.categories
    }))
  }

  clearSelection = () => {
    this.ref.current.clearSelection()
  }

  onSelectedChanged = (event) => {
    this.props.selectedLayers.forEach(lyr => {
      this.props.CartoContext.updateLayerFilter(lyr, this.props.field, event.detail, this.props.heading)
    })
  }

  render() {
    return (
      <AsCategoryWidget ref={this.ref} {...this.props} description={this.props.description} categories={this.state.categories} onSelectedChanged={this.onSelectedChanged}></AsCategoryWidget>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(withCarto(DpsCategoryWidget));
